import * as React from "react";
import { forwardRef } from "react";
const SvgCircle50 = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 50, height: 50, viewBox: "0 0 50 50", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 25, cy: 25, r: 25, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgCircle50);
export default ForwardRef;
